import { adminApi } from "../admin/api";

export const plannerApi = {
  async generateMatrix(payload) {
    const { data } = await adminApi.post("/planner/generate-matrix", payload, { timeout: 300000 });
    return data; // { pieces: [...] }
  },
  async savePlan(payload) {
    const { data } = await adminApi.post("/planner/plans", payload, { timeout: 60000 });
    return data;
  },
  async updatePlan(id, payload) {
    const { data } = await adminApi.put(`/planner/plans/${id}`, payload, { timeout: 60000 });
    return data;
  },
  async listPlans({ limit = 24 } = {}) {
    const { data } = await adminApi.get("/planner/plans", { params: { limit } });
    return data; // { items }
  },
  async getPlan(id) {
    const { data } = await adminApi.get(`/planner/plans/${id}`);
    return data;
  },
  async deletePlan(id) {
    await adminApi.delete(`/planner/plans/${id}`);
  },
  async regenerateCopy({ template, context, current_headline }) {
    const { data } = await adminApi.post(
      "/planner/regenerate-copy",
      { template, context, current_headline },
      { timeout: 90000 }
    );
    return data; // { headline, subtitle, cta, template }
  },
};
